import { KashuThemedLogo, LemPayLogo, PayovaLogo } from "./ui/icons";
import { cn, getHost } from "@/lib/utils";
import { useLoaderData } from "@tanstack/react-router";
import useGetWhiteLabelLogo from "@/features/white-label-logo/useGetWhiteLabelLogo";

type AppLogoProps = {
	className?: string;
	theme?: "light" | "dark";
};

export default function AppLogo({
	className = "",
	theme = "dark",
}: AppLogoProps) {
	const host = getHost();
	const { logo } = useLoaderData({ from: "__root__" });
	const { data: logoSrc } = useGetWhiteLabelLogo({ logoPath: logo });

	function getLogo() {
		if (host === "payova") {
			return (
				<PayovaLogo
					shouldDisplayLettersInWhite={theme === "light"}
					className="block h-full w-full object-contain"
				/>
			);
		}
		if (host === "kashu") {
			return (
				<KashuThemedLogo
					theme={theme}
					className="block h-full w-full object-contain max-w-20"
				/>
			);
		}
		if (host === "lempay") {
			return (
				<LemPayLogo className="block h-full w-full object-contain max-w-36" />
			);
		}
		return (
			<div>
				{logoSrc && (
					<img
						src={logoSrc}
						alt="Brand Logo"
						className="block max-w-16 w-16 aspect-square h-16 object-contain"
					/>
				)}
			</div>
		);
	}

	return (
		<div
			className={cn(
				`relative flex items-center justify-center leading-none ${className}`,
			)}
		>
			{getLogo()}
		</div>
	);
}
